import {
  connectIntegrationByToken,
  disconnectIntegration,
} from 'common/actions/integrations/common/actions/integrationActions'
import * as atypes from 'common/actions/integrations/common/constants/IntegrationsReduxActionTypes'
import {
  getFields,
  getLists,
} from 'common/actions/integrations/Klaviyo/actions/klaviyoIntegrationActions'

const initialState = {
  identityField: {
    value: null,
    option: null,
  },
  isDisconnecting: false,
  isLoadingLists: false,
  lists: [],
  fields: [],
  selectedList: null,
  selectedFields: [],
  hasEmptyField: false,
}

const EMPTY_FIELD_MODEL = {
  key: null,
  manyChatField: {
    value: null,
  },
}

export default function integrationsReducer(state = initialState, action) {
  const { data } = action

  switch (action.type) {
    case atypes.INTEGRATION_RESET: {
      return {
        ...state,
        ...initialState,
      }
    }

    case atypes.KLAVIYO_SET_IDENTITY_FIELD: {
      return { ...state, identityField: data }
    }

    case atypes.KLAVIYO_SET_FIELD_EMPTINESS: {
      return { ...state, hasEmptyField: data }
    }

    case atypes.KLAVIYO_SET_CONTACT_LIST: {
      return { ...state, selectedList: data }
    }

    case atypes.KLAVIYO_SET_CONTACT_FIELDS: {
      return { ...state, selectedFields: data }
    }

    case getLists.pending.type: {
      return { ...state, isLoadingLists: true }
    }

    case getLists.fulfilled.type: {
      const { lists } = action.payload
      return { ...state, lists, isLoadingLists: false }
    }
    case getLists.rejected.type: {
      return { ...state, isLoadingLists: false }
    }

    case getFields.fulfilled.type: {
      const { fields } = action.payload
      return { ...state, fields }
    }

    case atypes.KLAVIYO_ADD_FIELD: {
      return {
        ...state,
        selectedFields: [...state.selectedFields, EMPTY_FIELD_MODEL],
      }
    }

    case connectIntegrationByToken.pending.type: {
      return { ...state, isConnecting: true }
    }

    case connectIntegrationByToken.fulfilled.type:
    case connectIntegrationByToken.rejected.type: {
      return { ...state, isConnecting: false }
    }

    case disconnectIntegration.pending.type: {
      return { ...state, isDisconnecting: true }
    }
    case disconnectIntegration.fulfilled.type: {
      return { ...state, isDisconnecting: false }
    }
  }

  return state
}
